import {Component, OnInit,Input,Output,EventEmitter, ViewChild,SimpleChanges} from '@angular/core';
import { FormBuilder, FormControl, FormGroup,Validators } from '@angular/forms';
import { GeneralService} from '../services/general.service';
import { IState,ITwoDigitDecimalInput} from '../Shared/interface';
import { MaskedTextBoxComponent } from '@syncfusion/ej2-angular-inputs';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ModalWrapperService } from '../services/modal-wrapper.service';
@Component({
    selector: 'app-vehicle-info-popup',
    templateUrl: './vehicle-info-popup.component.html',
    styleUrls: ['./vehicle-info-popup.component.scss'],
    standalone: false
})
export class VehicleInfoPopupComponent implements OnInit {
  VehicleInfoForm!: FormGroup;
  @Input() vehicleInfoData: any;
  @Input() statesList:IState[];
  get emptyStateList(): boolean {
   return !this.statesList || this.statesList.length === 0;
  }
  @Input() vehicleReqList: any[] = [];
  @Input() vehicleInfoCallScriptFields=[];
  @Input() section;
  public PhoneNumberMask: String = '(000)000-0000';
  @ViewChild("towingphone", { static: true }) public towingphoneInstance: MaskedTextBoxComponent;
  @ViewChild('editVehicleInfoModalRef', { static: true }) editVehicleInfoModalRef: ModalDirective;
  modalConfig = {
    backdrop: 'static'
  };
  public onStartfocus(args): void { 
    args.selectionStart = 1;
    args.selectionEnd = 1;
  }
  public onCreated(event, instance) {
    instance?.element.addEventListener("keydown", event => {
      if (event.keyCode == 46) {
        var pos = instance.element.selectionStart;
        if (instance.element.value[pos] == instance.promptChar)
          instance.element.selectionStart++;
      }
    });
  }
  public onValueChange(args, instance) {
    if (args.event && args.event.keyCode && args.event.keyCode == 46) {
      instance.element.selectionStart++;
    }
  }
  maxyear=new Date(new Date().getFullYear() + 1, 1, 1);
  dimensionDirectiveSetting: ITwoDigitDecimalInput = {
    Length: 4,
    IsCurrency: false,
    DefaultMinimum: false,
    MinimumValue: '0.01',
    MaximumValue: '9999.99',
    WholeValue: true,
  };
  @Output() licenceBlur=new EventEmitter<any>();
  @Output() save = new EventEmitter<any>();
  constructor(public fb:FormBuilder,public generalService:GeneralService, private modalWrapper: ModalWrapperService) { }
  ngOnInit(): void {
  this.VehicleInfoForm=this.fb.group({
        VehicleLicenceNumber: [''],
        StickerNumber: [''],
        VehicleMake: [''],
        VehicleModel: [''],
        VehicleColor: [''],
        VehicleYear: [''],
        VehicleVin: [''],
        VehicleLength: [''],
        VehicleState: [''],
        TowingCompanyName:[''],
        TowingCompanyPhone :[''],
        TowingCompanyAddress :['']
    })
  }
  ngOnChanges(changes: SimpleChanges): void {
  if (changes['vehicleInfoData'] && this.vehicleInfoData) {
    this.VehicleInfoForm.patchValue(this.vehicleInfoData);
  }
  if (changes['vehicleReqList'] && this.vehicleReqList?.length > 0) {
    this.mandatoryFieldsVehicles(this.vehicleReqList);
  }
}
onModalShown(): void {
  this.VehicleInfoForm.markAsPristine();
  this.VehicleInfoForm.markAsUntouched();
}
mandatoryFieldsVehicles(list: any[]): void {
  list.forEach(field => {
    if(field.Name=='StickerNo'){
      field.Name='StickerNumber'
    }
    const control = this.VehicleInfoForm.get(field.Name);
    if(!control)return;
    if(field.Name=='TowingCompanyPhone'){
      if(field.Required){
       control.setValidators([Validators.required,this.cellPhoneValidator]);
      }
      else{
       control.setValidators([this.cellPhoneValidator]);
      }
    }
    else{
      if (field.Required) {
       control.setValidators([Validators.required]);
      } else {
       control.clearValidators();
      }
    }
    control.updateValueAndValidity();
  });
  
}
public cellPhoneValidator(control: FormControl) {
    if ((control.value !== '') && (control.value !== null)) {
      if (control.value) {
        const isWhitespace = (control.value).trim().length < 10;
        const isValid = !isWhitespace;

        return isValid ? null : { 'lessThanTen': true };
      }
    }
}
licenceNumberCheck(value){
  this.licenceBlur.emit(value);
}
onKeyPress(event: KeyboardEvent): void 
  {
    const key = event.key;
    if (/[^A-Za-z0-9]/.test(key)) 
    {
      event.preventDefault(); 
    }
  }
onPaste(event: ClipboardEvent) 
{
  const pastedText = event.clipboardData.getData('text');
  let regexp = new RegExp('^[A-Za-z0-9]*$');
  if (!regexp.test(pastedText)) 
  {
    event.preventDefault(); 
  }
}
onYearChange(value) {
    let e = document.getElementById('vehicleyrm');
    if (value) {
      e.classList.add('isValid');
    } else {
      e.classList.remove('isValid');
    }
}
onSaveVehicleInfo(){
    this.save.emit(this.VehicleInfoForm.value)
}
onCancelVehicleInfo() {
  if (this.vehicleInfoData) {
    this.VehicleInfoForm.patchValue(this.vehicleInfoData);
  } else {
    this.VehicleInfoForm.reset();
  }
}
disableSave(): boolean {
  return !this.VehicleInfoForm.valid||!this.VehicleInfoForm.dirty;
}

openModal() {
  this.modalWrapper.openDirective(this.editVehicleInfoModalRef);
}

closeModal() {
  this.editVehicleInfoModalRef.hide();
}

}
